import { ALinkStandaloneSize } from '../../atoms/ALinkStandalone/index';
import { ABodySize, ABodyColor } from '../../atoms/ABody/index';

export enum MParagraphAlignment {
  Center = 'Center',
  Centered = 'Centered',
  Left = 'Left',
}

export enum MParagraphDEFAULT_I18N {
  seeMore = 'See More',
  seeLess = 'See Less',
}

export interface MParagraphABodyProps {
  bodyText?: string;
  size?: ABodySize;
  color?: ABodyColor;
}

export interface MParagraphALinkStandaloneProps {
  size?: ALinkStandaloneSize;
  externalLink?: boolean;
  text?: string;
}

export interface MParagraphI18nProviderProps {
  seeMore?: string;
  seeLess?: string;
}

export interface MParagraphProps {
  alignment?: MParagraphAlignment;
  truncated?: boolean;
  truncateLines?: number;
  expanded?: boolean;
  bodySize?: ABodySize;
  bodyColor?: ABodyColor;
  truncationLinkSize?: ALinkStandaloneSize;
  children?: string;
  aBody?: MParagraphABodyProps;
  aLinkStandalone?: MParagraphALinkStandaloneProps;
  className?: string;
  i18nProperties?: MParagraphI18nProviderProps;
}
